import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Global from "./Global";

const loadScript = (url) => {
        const existingScript = document.querySelector(`script[src="${url}"]`)
        if (existingScript) {
            existingScript.parentNode.removeChild(existingScript)
        }

        const script = document.createElement('script')
        script.src = url
        script.async = false
        document.body.appendChild(script)
}

const loadJSLibs =  () => {
    const scripts = [
        `${window.location.origin+Global.frontend}/assets/BackOffice/libs/jquery/jquery.min.js`,
        `${window.location.origin+Global.frontend}/assets/BackOffice/libs/bootstrap/js/bootstrap.bundle.min.js`,
        `${window.location.origin+Global.frontend}/assets/BackOffice/libs/metismenu/metisMenu.min.js`,
        `${window.location.origin+Global.frontend}/assets/BackOffice/libs/simplebar/simplebar.min.js`,
        `${window.location.origin+Global.frontend}/assets/BackOffice/libs/node-waves/waves.min.js`,
        `${window.location.origin+Global.frontend}/assets/BackOffice/js/app.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/jquery-3.6.0.min.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/jquery-migrate-3.3.2.min.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/bootstrap.min.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/jquery.easing.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/jquery-waypoints.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/jquery-validate.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/jquery.prettyPhoto.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/slick.min.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/numinate.min.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/imagesloaded.min.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/jquery-isotope.js`,
        `${window.location.origin+Global.frontend}/assets/FrontOffice/js/main.js`
    ];

    for (const script of scripts) {
         loadScript(script)
    }
}

export function JSLibsLoader2() {
    const location = useLocation()
    const[lastLocation,setlastLocation]=useState("")

    useEffect(() => {
        if(lastLocation!=location.pathname){
            setlastLocation(location.pathname)
        }else{
            return
        }

        const loadScripts = async () => {
             loadJSLibs()
        }

        loadScripts()
    }, [location])

    return null
}




export default function JSLibsLoader() {

    useEffect(() => {


        const loadScripts = async () => {
             loadJSLibs()
        }

        setTimeout(()=>{
            loadScripts()
        },1000)
        
    }, [])

    return null
}
